import { CuttingState } from "./CuttingState.d";
import { ShipmentState } from "./ShipmentState.d";
import { ShipmentType } from "./ShipmentType.d";
import { UserType } from "./UserType.d";
import { CordwoodMeasurementType } from "./CordwoodMeasurementType.d";


import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity TimberStorages


export interface TimberStorage {
    id: ID;

    
    name: string;

    
    cuttingId: ID;

    
    locationId: ID;

    
    forestOwnerId?: ID;

    
    scopeGroupId: ID;

    }

export interface FilterAdvancedPresentationRequest {
    list: ListRequest,
    filter: {
        
            name?: string,
        
    
    

            forestOwnerId?: ID,
        
    
    forestOwnerIdInclude: boolean,



        cuttingIdRefs?: ID[],
        locationIdRefs?: ID[],
        forestOwnerIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}



export interface CreateTimberStorage {
    
    name: string;

    
    cuttingId: ID;

    
    locationId: ID;

    
    forestOwnerId?: ID;

    
    }


export interface UpdateTimberStorage {
    
    name: string;

    
    
    locationId: ID;

    
    forestOwnerId?: ID;

    
    }

export interface PresentationTimberStorageRequest {
    list: ListRequest,
    filter: {
        name: string,
        nameOr: boolean,
        cuttingIdRefs?: ID[],
        locationIdRefs?: ID[],
        forestOwnerIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryTimberStorage {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: TimberStorage): PrimaryTimberStorage | undefined {
        return entity ? new PrimaryTimberStorage(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryTimberStorage {
        return new PrimaryTimberStorage(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryTimberStorage {
        let vals = path?.split('/');
        return new PrimaryTimberStorage(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryTimberStorage[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: TimberStorage): string {
    let fields = entity ? [
    entity.name,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityTimberStorage {
    id: PrimaryTimberStorage;
    data: UpdateTimberStorage;


    constructor(id: PrimaryTimberStorage, data: UpdateTimberStorage) {
        this.id = id;
        this.data = data;
    }
}
